import React from 'react'

interface DurationIconProps {
  size?: number
  className?: string
}

export const DurationIcon: React.FC<DurationIconProps> = ({ size = 17, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M11.66 0.66L15.66 4.66" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.16 5.66V8.66" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.16 15.66C10.75 15.66 13.66 12.75 13.66 9.16C13.66 5.57 10.75 2.66 7.16 2.66C3.57 2.66 0.66 5.57 0.66 9.16C0.66 12.75 3.57 15.66 7.16 15.66Z" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)
